var map = {
	"./ArrowGreen.png": "2663",
	"./ArrowOrange.png": "9bce",
	"./ArrowPink.png": "e133",
	"./ArrowPurple.png": "e61c",
	"./ArrowRed.png": "8155",
	"./ArrowYellow.png": "1fa2",
	"./ConcurrencyCriticalSection.gif": "8ffe",
	"./ConcurrencyGifDeadlock.gif": "2751",
	"./ConcurrencyGifNondeterminism.gif": "0dbc",
	"./ConcurrencyGifRaceCondition.gif": "48f6",
	"./ConcurrencyGifStarvation.gif": "ce38",
	"./DeliveryConditional.png": "4ad6",
	"./DeliveryLimited.png": "f053",
	"./DeliveryUnconditional.png": "d7ff",
	"./DeliveryUniversal.png": "a3d6",
	"./DirectionSwitch.png": "4226",
	"./ExchangePoint.png": "06e2",
	"./PackageConditional.png": "8d57",
	"./PackageLimited.png": "35bf",
	"./PackageUnconditional.png": "ebd4",
	"./TestButtonExplainer.gif": "2a7b",
	"./parallelLogo.png": "c02f",
	"./parallelLogoReverse.png": "8f5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d19";